import { render, staticRenderFns } from "./ChatMessageReplyButton.vue?vue&type=template&id=3986cffc&"
import script from "./ChatMessageReplyButton.vue?vue&type=script&setup=true&lang=js&"
export * from "./ChatMessageReplyButton.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports